import { ChevronLeft, ChevronRight } from "lucide-react";
import RatingStars from "./RatingStars";
import TestimonialCard from "./TestimonialCard";

const MobileTestimonial = ({
  currentTestimonial,
  onPrev,
  onNext,
  currentIndex,
  total,
  onDotClick,
}) => {
  return (
    <section className="md:hidden w-full bg-[#133B61] text-white flex-shrink-0">
      <div className="max-w-3xl mx-auto px-5 py-7">
        <TestimonialCard item={currentTestimonial} mobile />

        <div className="flex items-center justify-between mt-4">
          <RatingStars value={4} />
          <div className="flex items-center gap-3">
            <button
              onClick={onPrev}
              className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center"
              aria-label="Previous"
            >
              <ChevronLeft size={16} />
            </button>
            <button
              onClick={onNext}
              className="w-9 h-9 bg-white/10 rounded-full flex items-center justify-center"
              aria-label="Next"
            >
              <ChevronRight size={16} />
            </button>
          </div>
        </div>

        <div className="mt-6 flex items-center justify-center gap-2">
          {Array.from({ length: total }).map((_, i) => (
            <button
              key={i}
              onClick={() => onDotClick(i)}
              className={`w-2.5 h-2.5 rounded-full ${i === currentIndex ? "bg-white" : "bg-white/40"}`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default MobileTestimonial;
